import React from 'react'
import AnimationProvider from '../AnimationProvider'
export default function BackgroundImage ({ background_image }) {
  return (
    <AnimationProvider {...background_image}>
      <img
        className='absolute top-0 left-0 w-full h-full object-cover z-0 scale-125'
        src={background_image?.image?.url}
        alt='background'
      />
    </AnimationProvider>
  )
}
